export default __webpack_public_path__ + "05ca1eb14e778fdaea15217a015cd399.png";